import {KeyboardArrowDown} from '@mui/icons-material';
import {styled} from '@mui/material';
import {forwardRef} from 'react';
import {Dropdown, DropdownButton, DropdownMenu} from '../Dropdown';
import {NavItemButtonProps} from '../Nav/NavItemButton';
import {excludeComponentProps} from '../utils/excludeComponentProps';
import {navCssClassNames} from './navCssClassNames';
import {navItemButtonCss} from './navItemButtonCss';
import {NavigationLinkOptions} from './types';

export interface NavItemDropdownProps extends NavItemButtonProps {
    /**
     * Navigation items prop.
     * @default [];
     */
    items?: NavigationLinkOptions['subNavigationItems'];
    hasDivider?: boolean;
}

const StyledDropdownButton = styled(DropdownButton,
    excludeComponentProps('subNavigationItems', 'orientation', 'size', 'level', 'label', 'hasDivider')
)<NavItemButtonProps>(navItemButtonCss);

export const NavItemDropdown = forwardRef<HTMLDivElement, NavItemDropdownProps>(({
    children, items, hasDivider, ...props
}, ref) => (
    <Dropdown>
        <StyledDropdownButton
            {...props}
            className={navCssClassNames.itemDropdownButton}
            endIcon={<KeyboardArrowDown/>}
            orientation='top'
            ref={ref}
        >
            {children}
        </StyledDropdownButton>
        <DropdownMenu
            className={navCssClassNames.itemDropdownMenu}
            hasDivider={hasDivider}
            items={items}
        />
    </Dropdown>
));

NavItemDropdown.displayName = 'NavItemDropdown';
